:host {
  --card-background-color: var(--white-layout-302-level-1-elevation);
  --card-border-color: var(--chart-100-pressed);
  --card-content-color: var(--body-text-arrows-400);
  --card-max-width: 1072px;
}

:host {
  display: block;
  max-width: var(--card-max-width);
  background-color: var(--card-background-color);
  border-radius: 4px;
  border: 1px solid;
  border-color: var(--card-border-color);
  padding: calc(2 * var(--spacer));
  transition: border 500ms ease-out;
  cursor: pointer;
}

:host(:hover) {
  --card-border-color: var(--main-titles-inputs-600);
  box-shadow: 0px 0px 10px 0px var(--chart-104-pressed);
}

:host(:focus) {
  --card-border-color: var(--blue-layout-500-focus);
}

:host([selected]) {
  --card-border-color: var(--blue-layout-301-active);
}

:host([selected]:hover) {
  --card-border-color: var(--blue-layout-301-active);
  box-shadow: 0px 0px 10px 0px var(--chart-104-pressed);
}

:host([disabled]) {
  --card-border-color: var(--chart-100-pressed);
  --card-content-color: var(--body-text-arrows-400);
  cursor: none;
  pointer-events: none;
}

::slotted(*) {
  color: var(--card-content-color);
}

.label {
  margin-bottom: calc(2 * var(--spacer));
}
